// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID;

if (!META_PIXEL_ID) {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.warn("Meta Pixel ID is not set in environment variables.");
  }
}

export function MetaPixel() {
  if (!META_PIXEL_ID) return null;
  return (
    <>
      <script
        // biome-ignore lint/security/noDangerouslySetInnerHtml: Static vendor bootstrap contains only the build-time pixel id.
        dangerouslySetInnerHTML={{
          __html: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');`,
        }}
      />
      <noscript>
        <img
          height="1"
          width="1"
          alt=""
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
}
